/**
 * Elements custom emettant les evenements de vue Shopify.
 *
 * `createViewEventElement` fabrique une classe qui lit l'attribut
 * `view-event-payload` — serialise cote serveur par le filtre Liquid
 * `standard_event_data` — et emet l'evenement correspondant.
 *
 *   <product-component>     -> product_viewed
 *   <collection-component>  -> collection_viewed
 *   <cart-items-component>  -> cart_viewed
 *
 * Le dernier est le plus important ici : le panier de ce theme est un
 * tiroir, la page /cart n'est jamais visitee, et `cart_viewed` vaut donc
 * zero aujourd'hui.
 *
 * ADAPTATION PAR RAPPORT A HORIZON : Horizon declare son panier avec
 * `view-event-trigger="dialog"` parce que son tiroir est un vrai <dialog>
 * (shopify-theme-horizon/snippets/cart-drawer.liquid:47). Ici le tiroir est
 * un <cart-drawer> pilote par une classe `.active`, et ce declencheur ne
 * partirait jamais. On utilise donc `intersect` : `.drawer__inner` est en
 * `transform: translateX(100%)` hors ouverture (assets/component-cart-drawer.css:28)
 * et revient a `translateX(0)` sur `.drawer.active` (l.77-78) — l'element est
 * donc hors viewport tant que le tiroir est ferme, et l'evenement part
 * exactement a son ouverture.
 *
 * Modele : shopify-theme-horizon/assets/view-event-elements.js
 */
import { createViewEventElement } from '@shopify/events';
import { isDesignMode } from '@theme/standard-events-utils';

// Dans l'editeur, chaque re-rendu de section reconstruit les elements et
// relancerait l'observation : autant ne jamais les definir.
if (!isDesignMode()) {
  define('product-component', { defaultTrigger: 'intersect' });
  define('collection-component');
  define('cart-items-component', { defaultTrigger: 'intersect' });
}

/**
 * @param {string} tagName
 * @param {object} [options]
 */
function define(tagName, options) {
  try {
    if (customElements.get(tagName)) return;

    customElements.define(
      tagName,
      options ? createViewEventElement(HTMLElement, options) : createViewEventElement(HTMLElement)
    );
  } catch (error) {
    // Element non defini : le contenu reste rendu, seule la mesure manque.
    // Un <product-component> inconnu se comporte comme un <div> inline.
  }
}
